import { Star } from 'lucide-react'

import { Badge } from '../../../../Theme'
import { useProductAttributes } from '../../../state'

export function RewardPoints() {
  const { rewardPoints } = useProductAttributes()

  if (!rewardPoints || rewardPoints <= 0) {
    return null
  }

  return (
    <div className="bg-cards-bg p-4 mb-3 xl:mb-5 rounded-lg">
      <div className="flex items-center justify-start gap-2">
        <Star className="w-5 h-5 text-custom-green fill-custom-green" />
        <div className="flex flex-col">
          <Badge variant="success" className="text-base px-0 py-1">
            {rewardPoints} puncte bonus
          </Badge>
          <span className="font-main-font text-sm xl:text-base text-second-btn-bg mt-1">
            Cumpara acest produs si castiga {rewardPoints} puncte bonus!
          </span>
        </div>
      </div>
    </div>
  )
}
